<template>
  <div class="auth-list">
    <el-row class="filter-wrap" :gutter="20">
      <el-col :span="6">
        <el-input v-model="form.nameOrCode" size="small" placeholder="合同名称/编号" @keyup.enter.native="onSearch"></el-input>
      </el-col>
      <el-col :span="6">
        <el-input v-model="form.customerName" size="small" placeholder="客户名称" @keyup.enter.native="onSearch"></el-input>
      </el-col>
      <el-col :span="6" class="input-group">
        <el-input v-model="form.contractMoneyMin" size="small" placeholder="最小合同金额" @keyup.enter.native="onSearch" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
        <span>~</span>
        <el-input v-model="form.contractMoneyMax" size="small" placeholder="最大合同金额" @keyup.enter.native="onSearch" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
      </el-col>
      <el-col :span="6">
        <el-button type="default" size="small" @click="onReset">重置</el-button>
        <el-button type="primary" size="small" @click="onSearch">搜索</el-button>
      </el-col>
    </el-row>
    <div class="table-wrap">
       <p class="table-count">合同条数：{{ page.total }}条</p>
      <el-table :data="tableData" v-loading="tableLoading" size="mini">
        <el-table-column label="合同名称" prop="name" align="center">
          <template slot-scope="scope">
            <p>{{ scope.row.name }}</p>
            <p>{{ scope.row.code }}</p>
          </template>
        </el-table-column>
        <el-table-column label="合同金额" prop="money" align="center">
          <template slot-scope="scope">
            {{ readableNum(scope.row.money) }}
          </template>
        </el-table-column>
        <el-table-column label="客户名称" prop="customerName" align="center"></el-table-column>
      
        <el-table-column label="业务负责人" prop="businessPrincipal" align="center"></el-table-column>
        <el-table-column label="合同附件" prop="path" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="lookContract(scope.row.fileDTOList)">查看合同附件</el-button>
          </template>
        </el-table-column>
        <el-table-column label="审批状态" prop="settlementStatus" align="center">
          <template slot-scope="scope">
            <p>
              {{ approveConfig.getAppointed("statusSettlement", scope.row.settlementStatus, "") }}
            </p>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button v-if="scope.row.settlementStatus===0" type="text" size="small" @click="toAssess(scope.row.id)">审批</el-button>
            
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-wrap">
        <el-pagination background @size-change="sizeChange" @current-change="currentChange" :current-page.sync="page.pageNum" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="page.pageSize"
          layout="sizes, prev, pager, next, jumper" :total="page.total">
        </el-pagination>
      </div>
    </div>
    <!-- 合同附件 -->
    <el-dialog title="查看合同附件" width="40%" :visible.sync="dialogTableVisible">
      <el-table :data="gridData">
        <el-table-column align="center" property="date" label="合同附件">
          <template slot-scope="scope">
            <filePreview :fileList="scope.row.fileList" :modalShow="false"></filePreview>
          </template>
        </el-table-column>
        <el-table-column align="center" property="sealType" label="盖章类型">
          <template slot-scope="scope">
            {{sealType[scope.row.sealType]}}
          </template>
        </el-table-column>
        <el-table-column align="center" property="date" label="盖章状态">
          <template slot-scope="scope">
            {{sealStatus[scope.row.sealStatus]}}
          </template>
        </el-table-column>
        <el-table-column align="center" property="name" label="合同扫描件">
          <template slot-scope="scope">
            <filePreview :fileList="scope.row.scannedCopyList" :modalShow="false"></filePreview>
            <!-- <div v-for="(item,index) in scope.row.scannedCopyList" :key="index">
              <a class="link chaochu" href="javascript:void(0);" @click="downloadFile(item.path, item.name)" :download="item.name">{{ item.name }}</a>
            </div> -->
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import util from "@/util/util";
import validate from "@/util/validate";
import { contractConfig } from "@/const/config/contract";
import { customConfig } from "@/const/config/custom";
import { settlementList } from "@/api/approve/contract";
import { approveConfig } from "@/const/config/approve";
export default {
  props: ["type"],
  data() {
    return {
      approveConfig,
      object: "",
      form: {
        nameOrCode: "",
        customerName: "",
        contractMoneyMin: "",
        contractMoneyMax: "",
      },

      page: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },

      tableLoading: false,
      tableData: [],
      gridData:"",
      dialogTableVisible:false,
      sealType:['不盖章','公章','合同章'],
      sealStatus:['不盖章','待申请盖章','盖章审核中','盖章审核不通过','待盖章','已盖章','已作废'],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    lookContract(data){
      this.gridData = data;
      this.dialogTableVisible = true;
    },
    /**
     * 监听分页器每页显示的条数变化
     * @param val 条数
     */
    sizeChange(val) {
      this.page.pageNum = 1;
      this.page.pageSize = val;
      this.getList();
    },
    /**
     * 监听页数变化
     * @param val 当前页数
     */
    currentChange(val) {
      this.page.pageNum = val;
      this.getList();
    },
    onReset() {
      this.form = {
        nameOrCode: "",
        customerName: "",
        contractMoneyMin: "",
        contractMoneyMax: "",
      };
      this.onSearch();
    },
    onSearch() {
      if (this.form.contractMoneyMin && this.form.contractMoneyMax) {
        if (
          parseInt(this.form.contractMoneyMin) >
          parseInt(this.form.contractMoneyMax)
        ) {
          this.$message.error("最小合同金额不能大于最大合同金额");
          return;
        }
      }
      this.page.pageNum = 1;
      this.getList();
    },
    getList() {
      let queryObj = validate.removeFilterNull(this.form);
      queryObj.pageNum = this.page.pageNum;
      queryObj.pageSize = this.page.pageSize;

      queryObj.auditFlag = customConfig.Status[this.type];
      this.tableLoading = true;
      settlementList(queryObj)
        .then((res) => {
          this.tableData = res.data || [];
          this.page.total = res.total;
          this.object = res.object;
          this.tableLoading = false;
        })
        .catch((err) => {
          this.tableData = [];
          this.page.total = 0;
          this.tableLoading = false;
        });
    },
    /**
     * 去审批页
     * @param id 合同id
     */
    toAssess(id) {
      let router = this.$router.push({
        path: "/check/contract-settlement/assess",
        query: {
          id,
        },
      });
      window.open(router.href, "_blank");
      window.open("about:blank","_self").close()
      window.close();//关闭当前页面
    },
    /**
     * 显示原因
     * @param reason 原因
     */
    onShowReason(reason) {
      reason = reason || "";
      this.$alert(reason, "审批不通过原因", {
        showConfirmButton: false,
        closeOnClickModal: true,
        customClass: "msgbox",
        callback: (action) => {},
      });
    },
    /**
     * 数字可读化
     * @param num 数字
     */
    readableNum(num) {
      if (!num && num !== 0) return "";
      return util.priceFormat(num);
    },
  },
  watch: {
    type(newVal, oldVal) {},
  },
};
</script>

<style lang="scss" scoped>
.table-wrap {
  margin-top: 20px;
}
</style>